/* KHUN CLUB · catálogo de series: filtros, búsqueda y orden en el navegador.
   El estado vive en la URL (?ship=freenbecky&anio=2024&gratis=1) para poder compartirlo,
   y los botones atrás/adelante del navegador funcionan. Sin JS se ve el catálogo completo. */
(() => {
  const raiz = document.querySelector('[data-kc-catalogo]');
  if (!raiz) return;

  const $ = (sel) => raiz.querySelector(sel);
  const indice = JSON.parse($('[data-kc-indice]').textContent);
  const lista = $('[data-kc-lista]');
  const items = new Map([...lista.children].map((li) => [li.dataset.h, li]));
  const POR_PAGINA = 24;

  const normalizar = (texto) =>
    String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const slug = (texto) => normalizar(texto).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const limpiarDemo = (texto) => String(texto).replace('[DEMO]', '').trim();
  const arr = (v) => (Array.isArray(v) ? v.filter(Boolean) : []);

  for (const s of indice) {
    s.tr = arr(s.tr);
    s.qn = normalizar(s.q);
  }

  // ---- Grupos de filtros: se arman con los valores que realmente existen en el índice ----
  const ORDEN_ESTADO = ['En emisión', 'Próximamente', 'Finalizada', 'Cancelada'];
  const EPISODIOS = [
    ['corta', 'Hasta 8', (n) => n > 0 && n <= 8],
    ['media', 'De 9 a 12', (n) => n >= 9 && n <= 12],
    ['larga', '13 o más', (n) => n >= 13],
  ];

  const opciones = (pares) => {
    const mapa = new Map();
    for (const [valor, etiqueta] of pares) if (valor) mapa.set(slug(valor), { valor, etiqueta: limpiarDemo(etiqueta) });
    return mapa;
  };
  const deIndice = (fn) => opciones(indice.flatMap(fn));

  // Mi GL (khun-mi-gl.js): solo aparece si la fan ya marcó alguna serie como vista
  const miGL = window.KhunMiGL;
  const hayVistas = Boolean(miGL && Object.values(miGL.todas()).some((x) => x.estado === 'vista'));

  const GRUPOS = [
    { clave: 'mi', titulo: 'Mi GL', ops: opciones(hayVistas ? [['ocultar', 'Ocultar las que ya vi']] : []),
      prueba: (s, v) => !v.includes('ocultar') || miGL.estado(s.h) !== 'vista' },
    { clave: 'estado', titulo: 'Estado', ops: deIndice((s) => [[s.e, s.e]]), prueba: (s, v) => v.includes(slug(s.e)),
      orden: (a, b) => ORDEN_ESTADO.indexOf(a.valor) - ORDEN_ESTADO.indexOf(b.valor) },
    { clave: 'anio', titulo: 'Año de estreno', ops: deIndice((s) => (s.a ? [[String(s.a), String(s.a)]] : [])), prueba: (s, v) => v.includes(String(s.a)),
      orden: (a, b) => b.valor - a.valor, compacto: true },
    { clave: 'ship', titulo: 'Ship', ops: deIndice((s) => s.s.map((h, i) => [h, s.sn[i]])), prueba: (s, v) => s.s.some((h) => v.includes(slug(h))) },
    { clave: 'productora', titulo: 'Productora y canal', ops: deIndice((s) => s.p.map((h, i) => [h, s.pn[i]])), prueba: (s, v) => s.p.some((h) => v.includes(slug(h))) },
    { clave: 'tropo', titulo: 'Tropos', ops: deIndice((s) => s.tr.map((t) => [t, t])), prueba: (s, v) => s.tr.some((t) => v.includes(slug(t))) },
    { clave: 'plataforma', titulo: 'Plataforma oficial', ops: deIndice((s) => s.pl.map((h, i) => [h, s.pln[i]])), prueba: (s, v) => s.pl.some((h) => v.includes(slug(h))) },
    { clave: 'acceso', titulo: 'Acceso', ops: opciones([['gratis', 'Gratis'], ['es', 'Subtítulos en español']]),
      prueba: (s, v) => (!v.includes('gratis') || s.g) && (!v.includes('es') || s.es), todas: true },
    { clave: 'eps', titulo: 'Episodios', ops: opciones(EPISODIOS.filter(([, , fn]) => indice.some((s) => fn(s.ep))).map(([k, e]) => [k, e])),
      prueba: (s, v) => EPISODIOS.some(([k, , fn]) => v.includes(k) && fn(s.ep)) },
    { clave: 'final', titulo: '¿Final feliz? (spoiler)', ops: deIndice((s) => [[s.ff, s.ff]]), prueba: (s, v) => v.includes(slug(s.ff)), spoiler: true },
  ].filter((g) => g.ops.size > 0);

  // ---- Estado ----
  const estado = { q: '', orden: 'recientes', filtros: {}, mostrar: POR_PAGINA, historial: [] };

  function leerURL() {
    const p = new URLSearchParams(location.search);
    estado.q = p.get('q') ?? '';
    estado.orden = ['recientes', 'az', 'empezar'].includes(p.get('orden')) ? p.get('orden') : 'recientes';
    estado.filtros = {};
    for (const g of GRUPOS) {
      const valores = (p.get(g.clave) ?? '').split(',').filter((v) => g.ops.has(v));
      if (valores.length) estado.filtros[g.clave] = valores;
    }
    estado.historial = Object.entries(estado.filtros).flatMap(([k, vs]) => vs.map((v) => [k, v]));
    estado.mostrar = POR_PAGINA;
  }

  function escribirURL(nueva) {
    const p = new URLSearchParams();
    if (estado.q) p.set('q', estado.q);
    if (estado.orden !== 'recientes') p.set('orden', estado.orden);
    for (const [k, vs] of Object.entries(estado.filtros)) if (vs.length) p.set(k, vs.join(','));
    const url = `${location.pathname}${p.toString() ? `?${p}` : ''}`;
    history[nueva ? 'pushState' : 'replaceState'](null, '', url);
  }

  // ---- Panel de filtros ----
  const form = $('[data-kc-filtros-form]');
  for (const g of GRUPOS) {
    const fs = document.createElement('fieldset');
    fs.className = `kc-filtros__grupo${g.compacto ? ' kc-filtros__grupo--compacto' : ''}`;
    if (g.spoiler) {
      fs.dataset.spoiler = '';
      fs.hidden = true;
    }
    const leyenda = document.createElement('legend');
    leyenda.className = 'kc-eyebrow';
    leyenda.textContent = g.titulo;
    fs.append(leyenda);
    const ops = [...g.ops].map(([v, o]) => ({ v, ...o }));
    if (g.orden) ops.sort(g.orden);
    else if (g.clave !== 'acceso' && g.clave !== 'eps') ops.sort((a, b) => a.etiqueta.localeCompare(b.etiqueta, 'es'));
    const LIMITE = 8;
    for (const [n, op] of ops.entries()) {
      const label = document.createElement('label');
      if (!g.compacto && n >= LIMITE) {
        label.hidden = true;
        label.dataset.extra = '';
      }
      label.className = 'kc-filtros__opcion';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = g.clave;
      input.value = op.v;
      label.append(input, document.createTextNode(op.etiqueta));
      fs.append(label);
    }
    // Grupos largos (tropos, ships, productoras): 8 opciones y un botón para ver el resto
    if (!g.compacto && ops.length > LIMITE) {
      const boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'kc-filtros__mas';
      boton.setAttribute('aria-expanded', 'false');
      boton.textContent = `Ver todos (${ops.length})`;
      boton.addEventListener('click', () => {
        const abrir = boton.getAttribute('aria-expanded') === 'false';
        fs.querySelectorAll('[data-extra]').forEach((l) => (l.hidden = !abrir));
        boton.setAttribute('aria-expanded', String(abrir));
        boton.textContent = abrir ? 'Ver menos' : `Ver todos (${ops.length})`;
        if (abrir) fs.querySelectorAll('[data-extra] input')[0]?.focus();
      });
      fs.append(boton);
    }
    form.append(fs);
  }

  form.addEventListener('change', (evento) => {
    const { name, value, checked } = evento.target;
    const actuales = new Set(estado.filtros[name] ?? []);
    if (checked) {
      actuales.add(value);
      estado.historial.push([name, value]);
    } else {
      actuales.delete(value);
      estado.historial = estado.historial.filter(([k, v]) => !(k === name && v === value));
    }
    estado.filtros[name] = [...actuales];
    estado.mostrar = POR_PAGINA;
    escribirURL(true);
    aplicar();
  });

  const spoiler = $('[data-kc-spoiler]');
  spoiler.addEventListener('change', () => {
    form.querySelectorAll('[data-spoiler]').forEach((fs) => (fs.hidden = !spoiler.checked));
  });

  // ---- Búsqueda y orden ----
  const buscar = $('[data-kc-buscar]');
  let espera;
  buscar.addEventListener('input', () => {
    clearTimeout(espera);
    espera = setTimeout(() => {
      estado.q = buscar.value.trim();
      estado.mostrar = POR_PAGINA;
      escribirURL(false);
      aplicar();
    }, 180);
  });

  const orden = $('[data-kc-orden]');
  orden.addEventListener('change', () => {
    estado.orden = orden.value;
    escribirURL(true);
    aplicar();
  });

  const ORDENES = {
    // Mismo criterio que Liquid (fecha o año); los empates conservan el orden del índice (sort estable)
    recientes: (a, b) => clave(b) - clave(a),
    az: (a, b) => limpiarDemo(a.t).localeCompare(limpiarDemo(b.t), 'es'),
    empezar: (a, b) => Number(b.rec) - Number(a.rec) || ORDENES.recientes(a, b),
  };

  // ---- Aplicar ----
  const conteo = $('[data-kc-conteo]');
  const activos = $('[data-kc-activos]');
  const vacio = $('[data-kc-vacio]');
  const mas = $('[data-kc-mas]');
  const cuentaFiltros = $('[data-kc-filtros-cuenta]');

  function aplicar() {
    const terminos = normalizar(estado.q).split(/\s+/).filter(Boolean);
    const grupos = GRUPOS.filter((g) => estado.filtros[g.clave]?.length);
    const coincide = (s) =>
      terminos.every((t) => s.qn.includes(t)) && grupos.every((g) => g.prueba(s, estado.filtros[g.clave]));
    const resultados = indice.filter(coincide).sort(ORDENES[estado.orden]);
    const hayFiltros = grupos.length > 0 || terminos.length > 0;

    // Orden y visibilidad de las tarjetas (se reordena el DOM para que el orden de tabulación sea el visual)
    const visibles = new Set(resultados.slice(0, estado.mostrar).map((s) => s.h));
    for (const s of resultados) lista.append(items.get(s.h));
    items.forEach((li, h) => {
      li.style.order = '';
      li.hidden = !visibles.has(h);
      li.classList.remove('kc-catalogo__item--destacada');
    });
    if (!hayFiltros && estado.orden === 'recientes' && resultados.length > 2) {
      const primera = resultados.find((s) => s.e === 'En emisión') ?? resultados[0];
      items.get(primera.h).classList.add('kc-catalogo__item--destacada');
      lista.prepend(items.get(primera.h));
    }

    const n = resultados.length;
    conteo.textContent = n === 0 ? 'Ninguna serie con esos filtros' : `${n} ${n === 1 ? 'serie' : 'series'}${hayFiltros ? ` de ${indice.length}` : ''}`;
    vacio.hidden = n > 0;
    mas.hidden = n <= estado.mostrar;
    if (!mas.hidden) mas.textContent = `Ver más series (${n - estado.mostrar} más)`;

    // Casillas, campos y etiquetas de filtros activos
    form.querySelectorAll('input').forEach((i) => (i.checked = estado.filtros[i.name]?.includes(i.value) ?? false));
    form.querySelectorAll('[data-extra]:has(input:checked)').forEach((l) => {
      const boton = l.closest('fieldset').querySelector('.kc-filtros__mas');
      if (boton?.getAttribute('aria-expanded') === 'false') boton.click();
    });
    if (estado.filtros.final?.length) {
      spoiler.checked = true;
      spoiler.dispatchEvent(new Event('change'));
    }
    if (buscar.value.trim() !== estado.q) buscar.value = estado.q;
    orden.value = estado.orden;

    activos.replaceChildren();
    let total = 0;
    for (const g of grupos) {
      for (const v of estado.filtros[g.clave]) {
        total += 1;
        const li = document.createElement('li');
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kc-tag kc-tag--amber';
        b.dataset.quitar = `${g.clave}:${v}`;
        b.setAttribute('aria-label', `Quitar filtro ${g.titulo}: ${g.ops.get(v).etiqueta}`);
        b.textContent = `${g.ops.get(v).etiqueta} ×`;
        li.append(b);
        activos.append(li);
      }
    }
    if (total > 1) {
      const li = document.createElement('li');
      li.innerHTML = '<button type="button" class="kc-tag" data-kc-limpiar>Limpiar todo</button>';
      activos.append(li);
    }
    cuentaFiltros.textContent = total ? `· ${total} ${total === 1 ? 'activo' : 'activos'}` : '';
  }

  function quitar(clave, valor) {
    estado.filtros[clave] = (estado.filtros[clave] ?? []).filter((v) => v !== valor);
    estado.historial = estado.historial.filter(([k, v]) => !(k === clave && v === valor));
    escribirURL(true);
    aplicar();
  }

  function limpiar() {
    estado.filtros = {};
    estado.historial = [];
    estado.q = '';
    estado.mostrar = POR_PAGINA;
    escribirURL(true);
    aplicar();
    buscar.focus();
  }

  raiz.addEventListener('click', (evento) => {
    const quitarBtn = evento.target.closest('[data-quitar]');
    if (quitarBtn) {
      const [clave, valor] = quitarBtn.dataset.quitar.split(':');
      quitar(clave, valor);
      (activos.querySelector('button') ?? buscar).focus();
      return;
    }
    if (evento.target.closest('[data-kc-limpiar]')) return limpiar();
    if (evento.target.closest('[data-kc-quitar-ultimo]')) {
      const ultimo = estado.historial.at(-1);
      if (ultimo) quitar(...ultimo);
      else limpiar();
      return;
    }
    if (evento.target.closest('[data-kc-mas]')) {
      const antes = estado.mostrar;
      estado.mostrar += POR_PAGINA;
      aplicar();
      // El foco pasa a la primera tarjeta nueva
      lista.querySelectorAll('li:not([hidden])')[antes]?.querySelector('a')?.focus();
    }
  });

  window.addEventListener('popstate', () => {
    leerURL();
    aplicar();
  });

  function clave(s) {
    // Anunciadas sin fecha ni año: como las más nuevas
    return s.f ? Number(s.f.replaceAll('-', '')) : (s.a || 9999) * 10000;
  }

  // ---- Panel: abierto en escritorio, plegable en móvil ----
  const panel = $('[data-kc-filtros]');
  const escritorio = matchMedia('(min-width: 990px)');
  const ajustarPanel = () => (panel.open = escritorio.matches);
  escritorio.addEventListener('change', ajustarPanel);
  ajustarPanel();

  // ---- Arranque ----
  leerURL();
  aplicar();
})();
